import { PartnerListItem } from '../types';

export const fetchPartnerList = async (countryCode: string): Promise<PartnerListItem[]> => {
  countryCode = countryCode.toLocaleUpperCase();
  return fetch(`/api/partner/partners?countryCode=${countryCode}`, {
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        return undefined;
      }
    })
    .then((response) => {
      return response;
    });
};
